import { createStore } from '@xstate/store'


import { type FileRoutesByTo, type FileRoutesById } from "@/routeTree.gen";

type BuildParams<T> = T extends { buildPath: (params: infer P) => string } ? P : never;

type BreadCrumbPathElement<T extends keyof FileRoutesByTo = keyof FileRoutesByTo> = {
  params: BuildParams<FileRoutesByTo[T]>;
  to: T;
  label: string;
};

type X = BuildParams<"/customer">

export const store = createStore({
  context: {
    path: [{ params: { customerId: "asdf", configurationId: "dsaf" }, to: "/customer/$customerId/configuration/$configurationId", label: "hallo" }], other: ""
  } as { path: BreadCrumbPathElement[], other: string },
  on: {
    changePath: (context, event: { newPath: BreadCrumbPathElement[] }) => ({
      ...context,
      path: [...event.newPath],
    }),
  }
})
